import {Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {NovaIconRegistry} from '@rds-nova/angular-icon';
import {ClientActionService} from './shared/client-action.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NovaIconRegistry],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly svc = inject(ClientActionService);

  constructor() {
    this.loadPayload();
  }

  private loadPayload() {
    const raw = new URLSearchParams(window.location.search).get('payload');
    if (!raw) return;
    try {
      const json = atob(raw);
      const parsed = JSON.parse(json)?.payload as { Request?: string, LoanNumber?: string, ClientName?: string };
      if (typeof parsed?.Request === 'string' && parsed.Request.length > 0) {
        this.svc.setRequest(parsed.Request);
      }
      if (typeof parsed?.LoanNumber === 'string' && parsed.LoanNumber.length > 0) {
        this.svc.setLoanNumber(parsed.LoanNumber)
      }
      if (typeof parsed?.ClientName === 'string' && parsed.ClientName.length > 0) {
        this.svc.setClientName(parsed.ClientName)
      }
    } catch (err) {
      console.warn('Failed to parse payload:', err);
    }
  }
}
